export const orderMethodsMixin = {
  methods: {
    completeCheckin() {
      const currentReservationId = this.reservation.id
      this.callConclusionApi({ update_checkin_process: true })
        .then(() => {
          this.$router.push({
            name: 'orderShow',
            params: { id: this.order.uuid},
            query: {redirect: this.$route.query.redirect}
          })

          const completedReservation = this.order?.reservations?.find(reservation => {
            return reservation.id == currentReservationId && reservation.guest_checkin_state == 'completed'
          })

          if (!this.$route.query.redirect || (this.$route.query.redirect && this.$route.query.redirect != 'otp') ){

            if (completedReservation) {
              this.$store.dispatch('layout/addAlert', {
                type: 'success',
                key: 'checkin_completed',
              })
            } else {
              this.$store.dispatch('layout/addAlert', {
                type: 'warning',
                key: 'checkin_to_complete',
              })
            }
          }

        })
        .catch(error => {
          console.log('Cannot completeCheckin', error)
        })
    },
    callConclusionApi(params) {
      return this.$store
        .dispatch('order/conclusionUpdateOrder', {
          order_id: this.order.id,
          reservation_id: this.reservation.id,
          params: params,
        })
    },
  },
}
